import React, { useCallback, useContext } from "react"
import { Container, AvatarContainer, UserContainer, LogoContainer, MenuContainer, Username } from './styles';
import { AppContext } from '../../../context'
import AvatarImg from '../../../assets/avatar.jpg'
import { HudButton, HudIconButton } from "../../molecules/hudButton"
import { IconType } from "../../atoms/icon"
import { themeColor } from "../../layout/global-style"
import { useMediaQuery } from "@react-hook/media-query";
import { useAuth } from "../../../services/auth";
import Logo from '../../atoms/logo/index'
import classNames from 'classnames';

const User = ({ revers }) => {
    const { user, logout } = useAuth();
    const { avatar = AvatarImg, username = "Anonymous" } = user || {};
    return (<UserContainer className={classNames({ revers })}>
        <AvatarContainer>
            {/*<HudButton disabled>*/}
            {/*    <img src={avatar ? avatar : AvatarImg} />*/}
            {/*</HudButton>*/}
            <HudButton disabled 
                color={revers ? themeColor.black : themeColor.white}
                disabledColor={revers ? themeColor.black : themeColor.white}
            >
                <Username>{username}</Username>
            </HudButton>
        </AvatarContainer>
        <HudIconButton
            icon={IconType.logout}
            fontColor={revers ? themeColor.black : themeColor.white}
            color={revers ? themeColor.black : themeColor.white}
            hoverColor={themeColor.red}
            onClick={logout}
        />
    </UserContainer>)
}

const MobileMenu = () => {
    const { modeSelection, langSelection, setLangSelection } = useContext(AppContext);

    const open = langSelection;
    const onClick = useCallback(e => {
        e.stopPropagation();
        setLangSelection(!open);
    });

    return (<Container>
        <MenuContainer><HudIconButton
            icon={open ? IconType.close : IconType.hamburger}
            onClick={onClick}
            disabled={modeSelection}
            fontColor={open ? themeColor.black : undefined}
            color={open ? themeColor.black : themeColor.white} hoverColor={open ? themeColor.red : undefined}
            frame
            revers={!open}
        /></MenuContainer>
        {open ? <User revers /> : <>
        </>}
    </Container>)
}

const Menu = () => <Container>
    <LogoContainer><Logo white /></LogoContainer>
    <User />
</Container>

export const Header = () => {
    const { langSelection } = useContext(AppContext);
    const isMobile = useMediaQuery('only screen and (max-width: 768px)');
    return isMobile ? (<MobileMenu />) : langSelection ? null : <Menu />;
}

Header.propTypes = {
}

export default Header;